import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import {ILiveScoreController} from "views/controllers/live_score/live_score.controller";
import React, {PropsWithChildren, Fragment} from "react";

export const LiveScore: React.FC<PropsWithChildren> = ({children}) => {
	useViewController<ILiveScoreController>(Bindings.LiveScoreController);

	return <Fragment>{children}</Fragment>;
};
